import { inject, Injectable, signal } from '@angular/core';
import { CustomerOrderService } from 'src/app/service/api/customer-order.service';
import { finalize, Subscription, timer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BoxService } from 'src/app/service/api/box.service';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  readonly showDialog = signal(false);
  readonly showDialogSpinner = signal(false);
  readonly dialogText = signal<string>('');
  readonly dialogButtonText = signal<string | null>(null);
  private customerOrderSvc = inject(CustomerOrderService);
  private boxSvc = inject(BoxService);

  private doorOpenedFlag = false;
  private thankYouTimer?: Subscription;

  constructor() {
    this.boxSvc.startListenAllChangedEntities().subscribe(() => {
      this.boxSvc.allChangedEntities$?.subscribe((data) => {
        console.log('DialogService: allChangedEntities$ emitted', data);
        this.thankYouAndLeave();
      });
    });
  }

  /**
   * Handles the process of taking a customer order by verifying the provided PIN.
   *
   * @param {string} pin - The PIN provided by the customer to authorize the order.
   * @return {void} This method does not return a value. It updates internal state and UI elements based on the result of the order taking process.
   */
  takeOrder(pin: string): void {
    this.doorOpenedFlag = false;
    this.showDialogSpinner.set(true);
    this.dialogText.set('Ověřuji PIN...');
    this.showDialog.set(true);
    this.dialogButtonText.set(null);

    this.customerOrderSvc
      .takeOrder(pin)
      .pipe(
        finalize(() => {
          this.showDialogSpinner.set(false);
        }),
      )
      .subscribe({
        next: (result) => {
          this.dialogText.set(result);
          this.doorOpenedFlag = true;
        },
        error: (error) => {
          this.dialogText.set(error);
          this.dialogButtonText.set('ZPĚT');
        },
      });
  }

  /**
   * Displays a thank-you message and handles the closure of the dialog.
   * The method checks if the door is open, and if true, sets appropriate dialog text,
   * waits for a specified duration, and then closes the dialog.
   *
   * @return {void} This method does not return a value.
   */
  private thankYouAndLeave(): void {
    if (!this.doorOpenedFlag) return;

    this.thankYouTimer?.unsubscribe();
    this.dialogButtonText.set(null);
    this.dialogText.set('Děkujeme za využití našich služeb.');
    this.thankYouTimer = timer(environment.thankYouWaitLimitMs).subscribe(() => {
      this.showDialog.set(false);
    });
  }
}
